import React, { useEffect, useState } from 'react'
import {
  SelectInput,
  NumberInput,
  ReferenceInput,
  TextInput,
  Edit,
  SimpleForm,
  AutocompleteInput,
  required,
  useInput,
  BooleanInput,
  Button,
  FormDataConsumer,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import AceEditor from 'react-ace'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/theme-textmate'

import { CustomToolbar } from '../CustomToolbar'
import { countryList, currencyList } from '../../constants'

const PageEdit = (props) => {
  const classes = useStyles()

  return (
    <Edit {...props} title="Pricing edit">
      <SimpleForm toolbar={<CustomToolbar />}>
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextInput source="id" disabled fullWidth className={classes.input} />
            </Grid>
            <Grid item xs={6}>
              <ReferenceInput
                fullWidth
                reference="organizations"
                label="Organizations Id"
                source="organization_id_data.id"
                className={classes.input}
              >
                <SelectInput source="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={6}>
              <ReferenceInput
                fullWidth
                reference="products"
                label="Product"
                source="product_id_data.id"
                validate={[required()]}
                className={classes.input}
              >
                <AutocompleteInput
                  optionText={(option) => `${option?.name || ''} (${option?.denomination || ''})`}
                />
              </ReferenceInput>
            </Grid>
            <Grid item xs={6}>
              <NumberInput fullWidth source="reference" label="RRP" className={classes.input} />
            </Grid>
            <Grid item xs={6}>
              <SelectInput
                source="method"
                fullWidth
                validate={[required()]}
                className={classes.input}
                optionText="id"
                choices={[
                  { id: 'absolute', name: 'Absolute' },
                  { id: 'percent', name: 'Percent' },
                ]}
              />
            </Grid>
            <Grid item xs={6}>
              <NumberInput fullWidth source="value" label="Sell price" className={classes.input} />
            </Grid>
            <Grid item xs={6}>
              <SelectInput
                fullWidth
                source="channel_code"
                validate={[required()]}
                className={classes.input}
                choices={[
                  { id: 'FACEBOOK', name: 'facebook' },
                  { id: 'PWA_APP', name: 'pwaApp' },
                ]}
              />
            </Grid>
            <Grid item xs={3}>
              <BooleanInput source="available" className={classes.input} />
            </Grid>
            <Grid item xs={3}>
              <BooleanInput source="auto_update" />
            </Grid>
            <Grid item xs={12}>
              <p className={classes.text}>Poin</p>
              <PoinInput source="poin" label="Poin" />
            </Grid>
            <Grid item xs={6}>
              <AutocompleteInput
                fullWidth
                label="Currency"
                source="currency"
                validate={[required()]}
                className={classes.input}
                choices={currencyList}
              />
            </Grid>
            <Grid item xs={6}>
              <AutocompleteInput
                fullWidth
                label="Country"
                source="country"
                validate={[required()]}
                className={classes.input}
                choices={countryList}
              />
            </Grid>
            <Grid item xs={12}>
              <div style={{ display: 'flex', gap: '30px' }}>
                <SelectInput
                  source="period_purchase_limit"
                  fullWidth
                  validate={[required()]}
                  className={classes.input}
                  choices={[
                    { id: 'daily', name: 'DAILY' },
                    { id: 'weekly', name: 'WEEKLY' },
                    { id: 'monthly', name: 'MONTHLY' },
                  ]}
                  disabled
                />
                <SelectInput
                  source="limit_type_purchase_limit"
                  fullWidth
                  validate={[required()]}
                  className={classes.input}
                  choices={[
                    { id: 'unlimited', name: 'UNLIMITED' },
                    { id: 'other', name: 'OTHER' },
                  ]}
                  disabled
                />
                <FormDataConsumer>
                  {({ formData, ...rest }) =>
                    formData.limit_type_purchase_limit.toUpperCase() === 'OTHER' && (
                      <NumberInput
                        source="limit_value_purchase_limit"
                        fullWidth
                        validate={[required()]}
                        className={classes.input}
                        {...rest}
                        disabled
                      />
                    )
                  }
                </FormDataConsumer>
              </div>
            </Grid>
          </Grid>
        </div>
      </SimpleForm>
    </Edit>
  )
}
export default PageEdit

/* STYLING */
const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    flexGrow: 1,
  },
  input: {
    marginBottom: '-20px',
  },
  text: {
    color: '#0000008A',
  },
}))

/* OTHER COMPONENT */
const PoinInput = (props) => {
  const [poinValue, setPoinValue] = useState('')
  const [isChanged, setIsChanged] = useState(false)
  const poin = useInput(props)

  useEffect(() => {
    setPoinValue(JSON.stringify(poin.input.value, null, '\t'))
    setIsChanged(false)
  }, [poin.input.value])

  function onChange(newValue) {
    setPoinValue(newValue)
    setIsChanged(true)
  }

  function saveToForm() {
    const parsed = JSON.parse(poinValue)
    poin.input.onChange(parsed)
  }

  return (
    <div>
      <AceEditor
        name="poin"
        style={{ height: '200px', width: '100%' }}
        mode="json"
        theme="textmate"
        onChange={onChange}
        value={poinValue}
      />
      {isChanged && (
        <Button variant="contained" size="small" color="primary" onClick={saveToForm}>
          <>Commit Changes</>
        </Button>
      )}
    </div>
  )
}
